import React, { Component } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

import Checkbox from '../helpers/checkbox';
import Loader from '../helpers/loader';
import Search from '../helpers/autocomplete';
import AppContext from '../app/AppContext';
import { isValidURL } from '../helpers/validationFunctions';
import countries from '../helpers/countries';
import ReactPixel from 'react-facebook-pixel';

class CreateOrganisation extends Component {
    static contextType = AppContext;

    constructor (props) {
        super(props);

        // Rewriting URL after social logins to avoid server error on page refresh
        if (
            window.location.href.includes('google') ||
            window.location.href.includes('facebook') ||
            window.location.href.includes('strava')
        ) {
            window.location.href = '/';
        }

        const initialCountryCodes = countries.map(countryCodes => countryCodes);
        this.state = {
            sportOptions: [],
            organisationSizes: [],
            organisationRegistrationPlatforms: [],
            countryCodeOptions: initialCountryCodes,
            inputErrors: {},
            formSubmitted: false,
            creationPage: 0,
            organisationName: '',
            organisationSize: '',
            organisationRole: '',
            organisationAddressLine1: '',
            organisationAddressLine2: '',
            organisationAddressCity: '',
            organisationAddressPostcode: '',
            organisationAddressCountry: '',
            organisationCountryCode: '',
            organisationNumber: '',
            organisationWebsite: '',
            organisationRegistrationPlatform: '',
            organisationSports: {},
        };
    }

    componentDidMount () {
        const token = this.context.token
            ? this.context.token
            : localStorage.getItem('token');
        const headers = {
            Authorization: `Token ${token}`,
        };

        let initialOrganisationSizes = [];
        let apiCallURL = `${process.env.REACT_APP_API_URL}/api/react/lookup/size_tiers/`;

        // Fetch Organisation Sizes
        axios
            .get(apiCallURL, { headers })
            .then(res => res.data)
            .then(data => {
                initialOrganisationSizes = data?.data?.map(({ id, title, range }) => ({ id, name: `${title} (${range})` }));

                this.setState({
                    organisationSizes: initialOrganisationSizes,
                });
            });

        // Fetch Race Categories
        let initialSports = [];
        apiCallURL = `${process.env.REACT_APP_API_URL}/api/react/lookup/race_categories/`;
        axios
            .get(apiCallURL, { headers })
            .then(res => res.data)
            .then(data => {
                initialSports = data.map(sport => sport);
                this.setState({
                    organisationSports: initialSports.reduce(
                        (options, option) => ({
                            ...options,
                            [option.id]: false,
                        }),
                        {}
                    ),
                });
                this.setState({
                    sportOptions: initialSports,
                });
            });

        // Fetch Organisation Registration Platforms
        let initialOrganisationRegistrationPlatforms = [];
        apiCallURL = `${process.env.REACT_APP_API_URL}/api/react/lookup/registration_platforms/`;

        axios
            .get(apiCallURL, { headers })
            .then(res => res.data)
            .then(data => {
                initialOrganisationRegistrationPlatforms = data?.data?.map(({ id, name }) => ({ id, name: `${name}` }));

                this.setState({
                    organisationRegistrationPlatforms: initialOrganisationRegistrationPlatforms,
                });
            });
    }

    handleChange = e => {
        if (e.target.name === 'organisationAddressCountry') {
            this.setState({
                [e.target.name]: e.target.value,
                organisationCountryCode: e.target.value,
            });
        }
        else if (e.target.name === 'organisationWebsite') {
            if (e.target.value.length > 3) {
                if (!isValidURL(e.target.value)) {
                    this.setState({
                        ...this.state.inputErrors,
                        websiteError: true,
                    });
                }
                else {
                    this.setState({
                        ...this.state.inputErrors,
                        websiteError: null,
                    });
                }
            }
            this.setState({
                [e.target.name]: e.target.value,
            });
        }
        else {
            this.setState({
                [e.target.name]: e.target.value,
            });
        }
    };

    checkSportsSelected = e => {
        e.preventDefault();
        if (
            Object.keys(this.state.organisationSports).every(
                k => !this.state.organisationSports[k]
            )
        ) {
            const errorList = {};
            errorList.sportsError = true;
            this.setState({
                inputErrors: errorList,
            });
        }
        else {
            this.handleSubmit();
        }
    };

    handleSubmit = () => {
        this.setState({ formSubmitted: true });
        let newCountryCode;
        let organiserWebsite = this.state.organisationWebsite;
        if (
            organiserWebsite.substring(0, 8) !== 'https://' &&
            organiserWebsite.substring(0, 7) !== 'http://'
        ) {
            organiserWebsite = `https://${organiserWebsite}`;
        }
        for (let i = 0; i < this.state.countryCodeOptions.length; i++) {
            if (
                this.state.countryCodeOptions[i].id.toString() ===
                this.state.organisationCountryCode
            ) {
                newCountryCode = this.state.countryCodeOptions[
                    i
                ].phone.toString();
            }
        }
        const organisationData = {
            name: this.state.organisationName,
            size_tier: this.state.organisationSize,
            role: this.state.organisationRole,
            address: {
                address_line1: this.state.organisationAddressLine1,
                address_line2: this.state.organisationAddressLine2,
                city: this.state.organisationAddressCity,
                postcode: this.state.organisationAddressPostcode,
                country_id: this.state.organisationCountryCode,
            },
            phone: newCountryCode + this.state.organisationNumber,
            website: organiserWebsite,
            registration_platform: this.state.organisationRegistrationPlatform,
        };
        const token = this.context.token
            ? this.context.token
            : localStorage.getItem('token');
        const headers = {
            Authorization: `Token ${token}`,
        };
        const apiCallURL = `${process.env.REACT_APP_API_URL}/api/react/organisations/`;
        axios
            .post(apiCallURL, organisationData, {
                headers,
            })
            .then(res => {
                ReactPixel.trackCustom('Organisation Created', { organisation: res.data.name });
                const selectedOrganisationItem = {
                    id: res.data.id,
                    name: res.data.name,
                    slug: res.data.slug,
                    published: res.data.published,
                    role: res.data.role,
                    is_premium_subscriber: res.data.is_premium_subscriber,
                };
                this.context.setSelectedOrganisation(selectedOrganisationItem);
                this.context.setOrgMembershipStatus('member-of-org');
                this.context.refreshUserDetails();
                this.props.history.push('/events/events');
            })
            .catch(error => {
                console.log(error);
                console.log('error.response',error?.response);
                if (error.response) {
                    const formErrors = Object.keys(error.response.data.errors);
                    const errorList = {};
                    if (formErrors.includes('phone')) {
                        errorList.phoneError = true;
                    }
                    if (formErrors.includes('website')) {
                        errorList.websiteError = true;
                    }
                    this.setState({
                        formSubmitted: false,
                        creationPage: 2,
                        inputErrors: errorList,
                    });
                }
            });
    };

    updatePage = e => {
        e.preventDefault();
        if (this.state.creationPage < 2) {
            this.setState({
                creationPage: this.state.creationPage + 1,
            });
        }
        else {
            this.handleSubmit();
        }
    };

    updatePageReverse = e => {
        e.preventDefault();
        if (this.state.creationPage > 0) {
            this.setState({
                creationPage: this.state.creationPage - 1,
            });
        }
    };

    handleCheckboxChange = changeEvent => {
        const id = changeEvent.target.value;
        this.setState(prevState => ({
            organisationSports: {
                ...prevState.organisationSports,
                [id]: !prevState.organisationSports[id],
            },
        }));
    };

    createCheckbox = option => (
        <Checkbox
            label={option.name}
            isSelected={this.state.organisationSports[option.id]}
            onCheckboxChange={this.handleCheckboxChange}
            key={option.id}
            value={option.id}
        />
    );

    createCheckboxes = () => this.state.sportOptions.map(this.createCheckbox);

    createSelectOptions = () =>
        this.state.organisationSizes.map(option => (
            <option key={option.id} value={option.id}>
                {option.name}
            </option>
        ));

    createCountryCodeSelectOptions = () =>
        this.state.countryCodeOptions.map(option => (
            <option key={option.id} value={option.id}>
                ({option.phone}) {option.name}
            </option>
        ));

    createCountrySelectOptions = () =>
        this.state.countryCodeOptions.map(option => (
            <option key={option.id} value={option.id}>
                {option.name}
            </option>
        ));

    createRegistrationPlatformSelectOptions = () =>
        this.state.organisationRegistrationPlatforms.map(option => (
            <option key={option.id} value={option.id}>
                {option.name}
            </option>
        ));

    render () {
        const {
            inputErrors,
            formSubmitted,
            creationPage,
            organisationName,
            organisationSize,
            organisationRole,
            organisationAddressLine1,
            organisationAddressLine2,
            organisationAddressCity,
            organisationAddressPostcode,
            organisationAddressCountry,
            organisationCountryCode,
            organisationNumber,
            organisationWebsite,
            organisationRegistrationPlatform,
        } = this.state;
        let formSection;
        let buttonText;
        if (creationPage === 1) {
            buttonText = 'Next';
            formSection = (
                <div>
                    <form className="log-in-form" onSubmit={this.updatePage}>
                        <div className="input-group">
                            <label htmlFor="organisation-name">
                                Name of your organisation{' '}
                                <span className="required-field">*</span>
                            </label>
                            <input
                                id="organisation-name"
                                value={organisationName}
                                onChange={this.handleChange}
                                className="input"
                                name="organisationName"
                                type="text"
                                placeholder="Top Events"
                                required
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="organisation-size">
                            Organisation size tier{' '}
                                <span className="required-field">*</span>
                            </label>
                            <select
                                className="input"
                                name="organisationSize"
                                onChange={this.handleChange}
                                value={organisationSize}
                                required
                            >
                                <option value="">Select number of annual participants</option>
                                {this.createSelectOptions()}
                            </select>
                        </div>
                        <div className="input-group">
                            <label htmlFor="organisation-role">
                                Your role in the organisation{' '}
                                <span className="required-field">*</span>
                            </label>
                            <input
                                id="organisation-role"
                                value={organisationRole}
                                onChange={this.handleChange}
                                className="input"
                                name="organisationRole"
                                type="text"
                                placeholder="Race Director"
                                required
                            />
                        </div>
                        <div className="log-in-form-submit">
                            <button
                                id="log-in-submit"
                                className="log-in-btn btn"
                            >
                                {buttonText}
                            </button>
                        </div>
                    </form>
                </div>
            );
        }
        else if (creationPage === 2) {
            buttonText = 'Submit for review';
            formSection = (
                <div>
                    <form className="log-in-form" onSubmit={this.updatePage}>
                        <div className="input-group">
                            <label htmlFor="organisation-address">
                                Organisation address{' '}
                                <span className="required-field">*</span>
                            </label>
                            <input
                                id="organisation-address"
                                value={organisationAddressLine1}
                                onChange={this.handleChange}
                                className="input org-address-input"
                                name="organisationAddressLine1"
                                type="text"
                                placeholder="Address line 1"
                                required
                            />
                            <input
                                id="organisation-address"
                                value={organisationAddressLine2}
                                onChange={this.handleChange}
                                className="input org-address-input"
                                name="organisationAddressLine2"
                                type="text"
                                placeholder="Address line 2 (optional)"
                            />
                            <div className="org-address-double-row">
                                <input
                                    id="organisation-address"
                                    value={organisationAddressCity}
                                    onChange={this.handleChange}
                                    className="input org-address-input org-address-input-half"
                                    name="organisationAddressCity"
                                    type="text"
                                    placeholder="City"
                                    required
                                />
                                <input
                                    id="organisation-address"
                                    value={organisationAddressPostcode}
                                    onChange={this.handleChange}
                                    className="input org-address-input org-address-input-half"
                                    name="organisationAddressPostcode"
                                    type="text"
                                    placeholder="Postcode"
                                    required
                                />
                            </div>
                            <select
                                className="input org-address-input"
                                id="organisation-address"
                                name="organisationAddressCountry"
                                onChange={this.handleChange}
                                value={organisationAddressCountry}
                                required
                            >
                                <option value="" disabled>
                                    Select country
                                </option>
                                {this.createCountrySelectOptions()}
                            </select>
                        </div>
                        <div className="input-group">
                            <label htmlFor="organisation-number">
                                Organisation contact number{' '}
                                <span className="required-field">*</span>
                            </label>
                        
                            <div className="input-phone-with-code">
                                <select
                                    className="input country-code-input"
                                    name="organisationCountryCode"
                                    onChange={this.handleChange}
                                    value={organisationCountryCode}
                                    required
                                >
                                    <option value="" disabled>
                                        Select code
                                    </option>
                                    {this.createCountryCodeSelectOptions()}
                                </select>
                                <input
                                    id="organisation-number"
                                    value={organisationNumber}
                                    onChange={this.handleChange}
                                    className="input org-number-input"
                                    name="organisationNumber"
                                    type="text"
                                    placeholder="7123456789"
                                    required
                                />
                            </div>
                            {inputErrors.phoneError ? (
                                <div className="small-form-error">
                                    Invalid phone number. Check the formatting
                                    of your number is correct.
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        <div className="input-group">
                            <label htmlFor="organisation-website">
                                Organisation website{' '}
                                <span className="required-field">*</span>
                            </label>
                           
                            <input
                                id="organisation-website"
                                value={organisationWebsite}
                                onChange={this.handleChange}
                                className="input"
                                name="organisationWebsite"
                                type="text"
                                placeholder="www.topevents.com"
                                required
                            />
                            {inputErrors.websiteError ? (
                                <div className="small-form-error">
                                    Invalid website. Check the formatting of
                                    your website address is correct.
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        <div className="input-group">
                            <label htmlFor="organisation-registration-platform">
                                Registration Platform{' '}
                                <span className="required-field">*</span>
                            </label>

                            <select
                                className="input org-registration-platform-input"
                                id="organisation-registration-platform"
                                name="organisationRegistrationPlatform"
                                onChange={this.handleChange}
                                value={organisationRegistrationPlatform}
                                required
                            >
                                <option value="" disabled>
                                    Select registration platform
                                </option>
                                {this.createRegistrationPlatformSelectOptions()}
                            </select>
                        </div>
                        <div className="log-in-form-submit">
                            <button
                                id="log-in-submit"
                                className="log-in-btn btn"
                            >
                                {buttonText}
                            </button>
                        </div>
                    </form>
                </div>
            );
        }
       
        else if (creationPage === 0) {
            buttonText = 'Create a new organisation';
            formSection = (
                <div>
                    <p className="organisation-list-copy">
                        Check if your organisation already exists on Racecheck
                        using the search below. If it does, please contact the
                        member of your team who owns it in order for them to
                        invite you to join.
                    </p>
                    {/* <input 
                        id="organisation-list"
                        value={organisationWebsite}
                        onChange={this.handleChange}
                        className="input"
                        name="organisationWebsite"
                        type="text"
                        placeholder="Search for your organisation">
                        </input> */}
                    <Search
                        placeholder={'Search for your organisation'}
                        apiEndpoint={
                            '/api/react/organisation-autocomplete-react/'
                        }
                    />
                    <div className="sign_up_divider divider-spaced">or</div>
                    <div className="log-in-form-submit">
                        <button
                            id="log-in-submit"
                            className="log-in-btn btn"
                            onClick={this.updatePage}
                        >
                            {buttonText}
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className="create-organisation-wrapper">
                {formSubmitted ? (
                    <div className="social-login-loading-container">
                        <Loader />
                        <p>Creating your organisation...</p>
                    </div>
                ) : (
                    <div className="logged_out_container">
                        <img
                            src={require('../../images/racecheck_logo_black.svg')}
                            width="250px"
                            alt="racecheck-logo"
                        />
                        <div className="log_in_container">
                            <h2>
                                {creationPage === 0
                                    ? 'Get started with your organisation'
                                    : 'Create your organisation'}
                            </h2>
                            {formSection}
                            {/* <div className="log-in-form-submit">
                            <button id="log-in-submit" className="log-in-btn btn" onClick={this.updatePage}>{buttonText}</button>
                        </div> */}
                            {creationPage === 0 ? (
                                <p className="log-in-sign-up-link">
                                    <span onClick={this.context.handleLogOut}>
                                        Click here
                                    </span>{' '}
                                    to cancel
                                </p>
                            ) : (
                                <p className="create-organisation-step">
                                    Step {creationPage} of 2{' '}
                                    <span className="create-org-bullet">•</span>{' '}
                                    <span
                                        className="create-org-back-btn"
                                        onClick={this.updatePageReverse}
                                    >
                                        Go back
                                    </span>
                                </p>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(CreateOrganisation);
